import { render, staticRenderFns } from "./FormFlights.vue?vue&type=template&id=1683af98&"
import script from "./FormFlights.vue?vue&type=script&lang=js&"
export * from "./FormFlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports